// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202511281533/js/" + chunkId + "." + {"44":"0339d98e","225":"96f2d073","481":"a8eae9dc","486":"42359846","770":"c2b61d84"}[chunkId] + ".0.3492294564780991.chunk.js";
};